import { isEmpty } from "./utils";

export default {
	
	/**
	 * 设置配置
	 * @param name
	 * @param value
	 */
	set(name,value){
		localStorage.setItem(name,value);
	},
	
	/**
	 * 设置json
	 * @param name
	 * @param value
	 */
	setJson(name,value){
		localStorage.setItem(name,JSON.stringify(value));
	},
	
	/**
	 * 获取配置
	 * @param name
	 */
	get(name,def=null){
		let data = localStorage.getItem(name);
		if(isEmpty(data)){
			return def;
		}
		
		return data;
	},
	
	/**
	 * 获取json配置
	 * @param name
	 */
	getJson(name,def=null){
		try{
			const content = localStorage.getItem(name);
			if(isEmpty(content)){
				return def;
			}
			
			return JSON.parse(content);
		}catch(e){
			return def;
		}
	},
	
	/**
	 * 删除缓存
	 * @param name
	 */
	remove(name){
		localStorage.removeItem(name);
	},
	
	/**
	 * 清空缓存
	 */
	clear(){
		localStorage.clear();
	}
};